import React, { useState, useContext, useEffect } from "react";
import { showInfoToast, showDangerToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { getPasswordComplexity, savePasswordComplexity } from "./systemSettingsService";
import { ChevronDown } from 'lucide-react';



export default function PasswordComplexitySection() {

  const { setPopup } = useContext(PopupContext);
  //const [idlePeriod, setIdleTimeoutPeriod] = useState('0');
  const [passwordLength, setPasswordLength] = useState('6');  
  const [upperCase, setUpperCase] = useState('0');
  const [lowerCase, setLowerCase] = useState('0');
  const [numbers, setNumbers] = useState('0');
  const [specialChars, setSpecialChars] = useState('0');

  const [collapsed, setCollapsed] = useState(true);

  // const setPeriod = false;
  const isStartDisabled = false;

  const fetchData = async () => {
    try {
        const response = await getPasswordComplexity();
        const passwordComplexitySettings = Array.isArray(response) ? response : response.data ?? [];

        // Convert the array into a key-value object for easy lookup
        const settingsMap = passwordComplexitySettings.reduce((acc, setting) => {
            acc[setting.name] = setting.value;
            return acc;
        }, {});

        // Only update state if the value exists in the map, 
        // otherwise keep the useState initial value
        if (settingsMap['passwordLength'])           setPasswordLength(settingsMap['passwordLength']);
        if (settingsMap['passwordUpperCase'])        setUpperCase(settingsMap['passwordUpperCase']);
        if (settingsMap['passwordLowerCase'])        setLowerCase(settingsMap['passwordLowerCase']);
        if (settingsMap['passwordNumber'])           setNumbers(settingsMap['passwordNumber']);
        if (settingsMap['passwordSpecialCharacter']) setSpecialChars(settingsMap['passwordSpecialCharacter']);

    } catch (error) {
      console.error('Error fetching password complexity settings:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const onSavePasswordComplexityClick = event => {
    // Validate password length before proceeding
    if (parseInt(passwordLength) < 6) {
      showDangerToast(
          'Password Length must be Min 6 Characters!',
          'Password Length'          
      );
      return; // Stop here, do not open confirm popup
    }
    
    showInfoToast('Setting Password Complexity', 'Password Complexity');
    // setPeriod(true);

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR Password Complexity',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
        const settingsArray = [
          { name: 'passwordLength', value: passwordLength, type: 'passwordcomplexity', note: '' },
          { name: 'passwordUpperCase', value: upperCase, type: 'passwordcomplexity', note: '' },
          { name: 'passwordLowerCase', value: lowerCase, type: 'passwordcomplexity', note: '' },
          { name: 'passwordNumber', value: numbers, type: 'passwordcomplexity', note: '' },
          { name: 'passwordSpecialCharacter', value: specialChars, type: 'passwordcomplexity', note: '' },
        ];
        await savePasswordComplexity(settingsArray);
    };
  };

  //const changePasswordLength = (value) => { setPasswordLength(value); }

  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Password Complexity</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <p className="oct_settings-description">
          Set the complexity requirements that determines how strong the user password must be.
        </p>

        <div className="oct_settings-form-grid">
            <div className="oct_settings-field">
                <label className="oct_settings-label">Password Length</label>
                <input
                    className="oct_settings-input-v2"
                    type="number"
                    min="6"
                    value={passwordLength}
                    onChange={event => setPasswordLength(event.target.value)}
                />
            </div>  
            {/* <div className="oct-settings-field--end">		
                <label className="oct_settings-hint-label">(min-Length is 6 Characters)</label>
            </div> */}
        </div>

        <div className="oct_settings-form-grid">
            <div className="oct_settings-field">
                <label className="oct_settings-label">Uppercase Letters (A-Z)</label>
                <input
                    className="oct_settings-input-v2"
                    type="number"
                    value={upperCase}
                    onChange={event => setUpperCase(event.target.value)}
                />
            </div>
            <div className="oct_settings-field">
                <label className="oct_settings-label">Lowercase Letters (a-z)</label>
                <input
                    className="oct_settings-input-v2"
                    type="number"
                    value={lowerCase}
                    onChange={event => setLowerCase(event.target.value)}
                />
            </div>
        </div>

        <div className="oct_settings-form-grid">
            <div className="oct_settings-field">
                <label className="oct_settings-label">Numbers (0-9)</label>
                <input
                    className="oct_settings-input-v2"
                    type="number"
                    value={numbers}
                    onChange={event => setNumbers(event.target.value)}
                />
            </div>
            <div className="oct_settings-field">
                <label className="oct_settings-label">Special Chracters (!@#$%^&*)</label>
                <input
                    className="oct_settings-input-v2"
                    type="number"
                    value={specialChars}
                    onChange={event => setSpecialChars(event.target.value)}
                />
            </div>
        </div>

        <button
          className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
          onClick={onSavePasswordComplexityClick}
        >
          Save Password Complexity
        </button>
      </div>
    </>
  );
}
